import { Route } from "react-router-dom";
import { CreateEmployee, UpdateEmployee } from "../Employee/Employee";
import { EmployeeList } from "../Employee/Table/EmployeeList";

export const EMPLOYEE_ROUTES = [
    <Route key="employees" path="/employees" element={<EmployeeList />} />,
    <Route key="employees-create" path="/employees/create_employee" element={<CreateEmployee />} />,
    <Route key="employees-update" path="/employees/update_employee/:id" element={<UpdateEmployee />} />
];
